<template>
  <div class="return-reasons-page">

    <!-- Header -->
    <b-card no-body class="rr-header-card mb-1">
      <b-card-body class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div class="icon-header mr-1">
            <feather-icon icon="RotateCcwIcon" size="22" />
          </div>
          <div>
            <h4 class="mb-0">Return Reasons</h4>
            <small class="text-muted">Gestiona los motivos de devolución por producto</small>
          </div>
        </div>
        <b-badge variant="primary" pill class="badge-total">
          {{ articulosBusqueda.length }} productos
        </b-badge>
      </b-card-body>
    </b-card>

    <!-- Card principal -->
    <b-card no-body class="rr-card">
      <b-card-body>
        <!-- Buscador -->
        <div class="rr-search-wrapper mb-1">
          <feather-icon icon="SearchIcon" size="18" class="rr-search-icon" />
          <b-form-input
            id="basicInput"
            placeholder="Buscar por producto o motivo de devolución..."
            v-model="buscar"
            class="rr-search-input"
          />
        </div>

        <!-- Info -->
        <div class="rr-info mb-1" v-if="articulosBusqueda.length > 0">
          <feather-icon icon="InfoIcon" size="14" class="mr-50" />
          Escribe los motivos separados por coma. Ejemplo: <strong>Too small, Wrong color, Defective</strong>
        </div>

        <!-- Tabla -->
        <b-table
          :items="articulosBusqueda"
          :fields="columnasSku"
          class="rr-table"
          striped
          hover
          responsive
          sort-icon-left
          show-empty
          empty-text="No se encontraron productos"
          ref="table"
        >
          <template #cell(title)="data">
            <div class="d-flex align-items-center">
              <div class="product-dot mr-75" :class="data.item.reasons_str ? 'dot-success' : 'dot-warning'"></div>
              <span class="product-title">{{ data.item.title }}</span>
            </div>
          </template>

          <template #cell(reasons_str)="data">
            <b-form-input
              placeholder="Motivo1, Motivo2, Motivo3..."
              v-model="data.item.reasons_str"
              class="rr-reason-input"
            />
          </template>

          <template #cell(options)="data">
            <b-button
              variant="flat-success"
              class="btn-icon rounded-circle btn-sm"
              @click="guardarReason(data.item)"
              v-b-tooltip.hover
              title="Guardar motivos"
            >
              <feather-icon icon="SaveIcon" size="16" />
            </b-button>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable , BFormCheckbox, BFormInput, BFormGroup, BModal, BCardText, BCardBody, BCard, BRow, BCol} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { $themeColors } from '@themeConfig'
import { useTimeout } from '@vueuse/shared'
import vSelect from 'vue-select'
import { forEach } from 'postcss-rtl/lib/affected-props'


export default {
  components: {
      BCardCode,
      BTable,
      BFormInput,
      BFormGroup,
      BRow,
      BCol,
      vSelect,
  },
  data () {
    return {       
      columnasSku: [
      {
        key: "title",
        label: "Producto",
        sortable: true,
        thStyle: { width: "25%" },
      },
      {
        key: "reasons_str",
        label: "Motivos de devolución",
        sortable: true,
      },
      {
        key: "options",
        label: "",
        thStyle: { width: "60px" },
      }
    ],
      articulos: [],
      articulosBusqueda: [],
      buscar: "",
    }
  },
  methods:{
    loadItems(){ 
      axios.post("/uso", {seccion:"return-reasons"});

      /*axios.get("/kpi/paypal").then(response => {
        const paypalData = response.data;

        console.log(paypalData);
        const currencies = new Set();

        paypalData.forEach(item => {
          const currency = item.transaction_info.transaction_amount.currency_code;
          currencies.add(currency);
        });

        console.log(currencies);

        
      });

      return;*/

          Promise.all([
            axios.get("/articulos/products"),
            axios.get("/return/reasons"),
            axios.get("/kpi/revolut"),
          ])
          .then(([productsResponse, reasonsResponse, revolutResponse]) => {
            const products = productsResponse.data;
            const reasons = reasonsResponse.data;

            console.log(revolutResponse);

            // Agrupar razones por product_id
            const reasonsMap = {};
            reasons.forEach(({ product_sku, reason }) => {
              if (!reasonsMap[product_sku]) {
                reasonsMap[product_sku] = [];
              }
              reasonsMap[product_sku].push(reason);
            });

            // Agregar la cadena de razones al producto correspondiente
            const enrichedProducts = products.map(product => {
              const productReasons = reasonsMap[product.shopify_product_id] || [];
              return {
                ...product,
                reasons_str: productReasons.join(", ")
              };
            });

            this.articulos = enrichedProducts;
            this.articulosBusqueda = enrichedProducts;
          })
          .catch(error => {
            console.error("Error en alguna de las solicitudes:", error);
          });


    },
    guardarReason(data){
      console.log(data);
      axios
          .post("/return/reasons", data)
          .then(response => {
              return response.data;
          })
          .then(res => {

            this.$swal({
                icon: 'success',
                title: data.title,
                text: 'Los motivos se han actualizado con exito: ('+data.reasons_str+').',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
          });
    },
  },
   mounted() { 
    this.loadItems();
  },
  watch: {
    buscar(){
      this.articulosBusqueda = this.articulos.filter(item => {
        const reasonLower = item.reasons_str.toLowerCase();
        const tituloLower = item.title.toLowerCase();
        const buscarLower = this.buscar.toLowerCase();
        return reasonLower.includes(buscarLower) || tituloLower.includes(buscarLower);
      });

    },
  }

}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

.return-reasons-page {

  .rr-header-card {
    border: none;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);

    .icon-header {
      width: 46px;
      height: 46px;
      border-radius: 12px;
      background: linear-gradient(135deg, #ea5455 0%, #f08182 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }

    .badge-total {
      font-size: 0.85rem;
      padding: 0.5rem 1rem;
    }
  }

  .rr-card {
    border: none;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  }

  .rr-search-wrapper {
    position: relative;

    .rr-search-icon {
      position: absolute;
      left: 14px;
      top: 50%;
      transform: translateY(-50%);
      color: #b4b7bd;
      z-index: 2;
    }

    .rr-search-input {
      padding-left: 42px;
      border-radius: 8px;
      border: 1px solid #ebe9f1;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #7367f0;
        box-shadow: 0 3px 10px 0 rgba(115, 103, 240, 0.15);
      }
    }
  }

  .rr-info {
    background: #fff8e1;
    border: 1px solid #ffe082;
    border-radius: 8px;
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
    color: #795548;
    display: flex;
    align-items: center;
  }

  .rr-table {
    border-radius: 8px;

    thead th {
      text-transform: uppercase;
      font-size: 0.75rem;
      letter-spacing: 0.5px;
      color: #6e6b7b;
      border-bottom: 2px solid #ebe9f1;
      padding: 0.8rem 1rem;
      white-space: nowrap;
    }

    tbody td {
      padding: 0.55rem 1rem;
      vertical-align: middle;
    }

    .product-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      flex-shrink: 0;
    }

    .dot-success {
      background-color: #28c76f;
    }

    .dot-warning {
      background-color: #ff9f43;
    }

    .product-title {
      font-weight: 500;
      color: #5e5873;
    }

    .rr-reason-input {
      border-radius: 6px;
      border: 1px solid #ebe9f1;
      font-size: 0.9rem;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #ea5455;
        box-shadow: 0 3px 10px 0 rgba(234, 84, 85, 0.15);
      }

      &::placeholder {
        color: #c4c4c4;
        font-style: italic;
      }
    }
  }
}
</style>